import { render, staticRenderFns } from "./EditVoice.vue?vue&type=template&id=9911d6b2&scoped=true"
import script from "./EditVoice.vue?vue&type=script&lang=js"
export * from "./EditVoice.vue?vue&type=script&lang=js"
import style0 from "./EditVoice.vue?vue&type=style&index=0&id=9911d6b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9911d6b2",
  null
  
)

export default component.exports